module.exports = __webpack_public_path__ + "static/img/b11.530481b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b11.jpg
// module id = JZZu
// module chunks = 1